import React from 'react';
import classNames from 'classnames';
import { Box } from '@mui/material';

import styles from './LiveIndicator.module.scss';

const LiveIndicator: React.FC<{ isLive?: boolean }> = ({ isLive = true }) => (
  <Box
    className={classNames({
      [styles.liveIndicator]: true,
      [styles['liveIndicator--disabled']]: !isLive,
    })}
    data-testid={isLive ? 'live-indicator' : 'live-indicator-disabled'}
  />
);

export default LiveIndicator;
